var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCartGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2511_5025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.01953 2.04207C1.01953 1.70052 1.29432 1.42574 1.63587 1.42574H2.80434C3.36932 1.42574 3.87009 1.75445 4.10379 2.24752H14.6586C15.334 2.24752 15.827 2.88954 15.6498 3.54183L14.5969 7.453C14.3787 8.25938 13.6468 8.82179 12.8121 8.82179H5.40323L5.54191 9.55369C5.59841 9.84388 5.85265 10.0545 6.14797 10.0545H13.5517C13.8933 10.0545 14.1681 10.3292 14.1681 10.6708C14.1681 11.0124 13.8933 11.2871 13.5517 11.2871H6.14797C5.25942 11.2871 4.4967 10.6554 4.33235 9.78482L3.00722 2.82534C2.98924 2.72775 2.9045 2.65841 2.80434 2.65841H1.63587C1.29432 2.65841 1.01953 2.38363 1.01953 2.04207ZM4.30667 13.3416C4.30667 13.1797 4.33855 13.0194 4.4005 12.8699C4.46245 12.7203 4.55324 12.5844 4.66771 12.47C4.78217 12.3555 4.91806 12.2647 5.06762 12.2028C5.21717 12.1408 5.37746 12.1089 5.53934 12.1089C5.70122 12.1089 5.86151 12.1408 6.01107 12.2028C6.16062 12.2647 6.29651 12.3555 6.41097 12.47C6.52544 12.5844 6.61624 12.7203 6.67818 12.8699C6.74013 13.0194 6.77202 13.1797 6.77202 13.3416C6.77202 13.5035 6.74013 13.6638 6.67818 13.8133C6.61624 13.9629 6.52544 14.0988 6.41097 14.2132C6.29651 14.3277 6.16062 14.4185 6.01107 14.4804C5.86151 14.5424 5.70122 14.5743 5.53934 14.5743C5.37746 14.5743 5.21717 14.5424 5.06762 14.4804C4.91806 14.4185 4.78217 14.3277 4.66771 14.2132C4.55324 14.0988 4.46245 13.9629 4.4005 13.8133C4.33855 13.6638 4.30667 13.5035 4.30667 13.3416ZM12.9354 12.1089C13.2623 12.1089 13.5759 12.2388 13.807 12.47C14.0382 12.7011 14.1681 13.0147 14.1681 13.3416C14.1681 13.6685 14.0382 13.9821 13.807 14.2132C13.5759 14.4444 13.2623 14.5743 12.9354 14.5743C12.6085 14.5743 12.2949 14.4444 12.0638 14.2132C11.8326 13.9821 11.7027 13.6685 11.7027 13.3416C11.7027 13.0147 11.8326 12.7011 12.0638 12.47C12.2949 12.2388 12.6085 12.1089 12.9354 12.1089ZM7.49108 5.53465C7.49108 5.81714 7.7222 6.04827 8.00469 6.04827H9.13464V7.17822C9.13464 7.46071 9.36577 7.69184 9.64826 7.69184C9.93075 7.69184 10.1619 7.46071 10.1619 7.17822V6.04827H11.2918C11.5743 6.04827 11.8054 5.81714 11.8054 5.53465C11.8054 5.25217 11.5743 5.02104 11.2918 5.02104H10.1619V3.89109C10.1619 3.6086 9.93075 3.37747 9.64826 3.37747C9.36577 3.37747 9.13464 3.6086 9.13464 3.89109V5.02104H8.00469C7.7222 5.02104 7.49108 5.25217 7.49108 5.53465Z",
    fill: "url(#paint0_linear_2511_5025)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2511_5025",
    x: 0.352539,
    y: 0,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2511_5025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2511_5025",
    x1: 8.35286,
    y1: 1.42574,
    x2: 8.35286,
    y2: 14.5743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartGradient);
export default __webpack_public_path__ + "static/media/icon-cart-gradient.e5aea1a57a3c71b3ebf91bd17cee4e32.svg";
export { ForwardRef as ReactComponent };